class PostnatalDiscussionTopic {
    public IsDiscussed: boolean;
    public Comments: string;

    public constructor(fields?: Partial<PostnatalDiscussionTopic>) {
        Object.assign(this, fields);
    }
}

export { PostnatalDiscussionTopic };
